<template>
  <q-layout
    class="dashboard-layout"
    :class="{ 'dashboard-layout__staging': isStagingEnvironment }"
  >
    <q-page-container>
      <q-page class="tw-flex tw-flex-col tw-overflow-hidden">
        <status-bar />

        <div class="tw-flex tw-flex-1 tw-flex-row tw-overflow-hidden">
          <Menu />
          <mobile-menu />

          <div
            class="tw-flex tw-h-full tw-flex-1 tw-flex-col tw-overflow-hidden"
          >
            <Header />

            <div class="tw-flex tw-flex-1 tw-flex-col tw-overflow-hidden">
              <slot />

              <countdown-authenticator
                v-if="showCountdownModal"
                :timer="timer"
                @reset-timer="resetTimer"
                @logout="logout"
              />

              <celebration-component
                v-if="celebrationVisible"
                :celebration-type="celebrationType"
              />
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script setup>
import CelebrationComponent from "components/global/celebration/CelebrationComponent.vue";
import Header from "components/layout/Header.vue";
import Menu from "components/layout/Menu.vue";
import MobileMenu from "components/layout/MobileMenu.vue";
import StatusBar from "components/layout/StatusBar.vue";
import CountdownAuthenticator from "components/modals/auth/CountdownAuthenticator.vue";
import { storeToRefs } from "pinia";
import { useCelebrationStore } from "store/modules/celebrationStore.js";

const celebrationStore = useCelebrationStore();
const { celebrationVisible, celebrationType } = storeToRefs(celebrationStore);
</script>

<script>
// TODO: Refactor this to composition API
import { clearAuthStorage, isStagingEnvironment } from "composables/useHelpers";
import { forgetIntendedPath } from "core/auth/intendedPath";

export default {
  data() {
    return {
      showCountdownModal: false,
      noInteractionTimer: 0,
      timer: null,
    };
  },
  mounted() {
    // TODO: Put this in a store so it will always works regardless if this component is mounted
    let self = this;

    //interval for no activity
    //Adds +1 every one second, reset on user interaction
    setInterval(function () {
      self.noInteractionTimer = self.noInteractionTimer + 1000; //add one second

      //No activity for 30 minutes
      let maxMinutes = 1800000; //30minutes
      let fiveMinutes = 300000;

      if (self.noInteractionTimer > maxMinutes - fiveMinutes) {
        let millisLeft = maxMinutes - self.noInteractionTimer;

        //calculate time left
        let timeLeft = self.millisToMinutesAndSeconds(millisLeft);
        self.timer = timeLeft;
        let minutes = timeLeft[0];
        let seconds = timeLeft[1];

        //Show countdown bar
        self.showCountdownModal = true;

        //Logout if time is expired
        if (minutes < 1 && seconds < 1) {
          self.logout();
        }
      }
    }, 1000);

    document.body.addEventListener("mousemove", this.handleInteraction);
    document.body.addEventListener("scroll", this.handleInteraction);
    document.body.addEventListener("keydown", this.handleInteraction);
    document.body.addEventListener("click", this.handleInteraction);
    document.body.addEventListener("touchstart", this.handleInteraction);
  },
  methods: {
    millisToMinutesAndSeconds(millis) {
      var minutes = Math.floor(millis / 60000);
      var seconds = ((millis % 60000) / 1000).toFixed(0);

      return [minutes, (seconds < 10 ? "0" : "") + seconds];
    },

    handleInteraction() {
      if (!this.showCountdownModal) {
        this.noInteractionTimer = 0;
      }
    },
    resetTimer() {
      this.noInteractionTimer = 0;
      this.showCountdownModal = false;
    },

    logout() {
      clearAuthStorage();
      forgetIntendedPath();

      // Not reload(): signed out, the guard would remember the current page
      // again for the next login.
      window.location.href = "/login";
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-layout {
  &__staging {
    @apply tw-border-t-4 tw-border-orange-500;
  }
}
</style>
